export const staffLoginCatalog = {
  en: {
    morning: 'Good Morning!',
    evening: 'Good Evening!',
    title: 'Welcome Back',
    morningText: 'A new day, new opportunities, and achievements waiting to happen.',
    eveningText: 'You still have opportunities today, and important tasks to complete.',
    morningCta: "Let's make it great!",
    eveningCta: "Let's finish strong!",
    portalTitle: 'One Portal. Every Team.',
    portalText: 'Secure access to the tools and resources every Arabian Academy employee needs to do their best work.',
    loginTitle: 'Sign In',
    loginSubtitle: 'Access your Arabian Academy workspace',
    username: 'Username',
    usernamePlaceholder: 'Enter your username',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    forgot: 'Forgot Password?',
    remember: 'Remember me',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    divider: 'or continue with email',
    email: 'Continue with Work Email',
    helper: 'Use your linked work email to continue through the secure academy email flow.',
    securityTitle: 'Authorized employees only',
    securityText: 'Access is based on your role and permissions.',
    roles: ['Administration', 'Instructors', 'Operations', 'Student Affairs', 'Finance', 'Support'],
    language: 'Language',
    theme: 'Toggle theme',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required',
    loginFailed: 'Login failed',
    networkError: 'Network error',
  },
  ar: {
    morning: 'صباح الخير!',
    evening: 'مساء الخير!',
    title: 'أهلًا بيك من جديد',
    morningText: 'يوم جديد، فرص جديدة، ونجاحات مستنية تتحقق.',
    eveningText: 'يومك لسه فيه فرص، ومهام مهمة مستنية تكتمل.',
    morningCta: 'خلّينا نبدأ بقوة!',
    eveningCta: 'خلّينا نكمل بقوة!',
    portalTitle: 'بوابة واحدة لكل فرق الأكاديمية',
    portalText: 'وصول آمن للأدوات والموارد اللي يحتاجها كل موظف في Arabian Academy علشان يشتغل بكفاءة.',
    loginTitle: 'تسجيل الدخول',
    loginSubtitle: 'ادخل إلى مساحة عملك في Arabian Academy',
    username: 'اسم المستخدم',
    usernamePlaceholder: 'ادخل اسم المستخدم',
    password: 'كلمة المرور',
    passwordPlaceholder: 'ادخل كلمة المرور',
    forgot: 'نسيت كلمة المرور؟',
    remember: 'تذكرني',
    signIn: 'تسجيل الدخول',
    signingIn: 'جاري تسجيل الدخول...',
    divider: 'أو الدخول بالبريد الإلكتروني',
    email: 'الدخول عبر البريد الإلكتروني',
    helper: 'استخدم البريد الإلكتروني المرتبط بحسابك لاستكمال الدخول الآمن.',
    securityTitle: 'للموظفين المصرح لهم فقط',
    securityText: 'الدخول يتم حسب دورك وصلاحياتك.',
    roles: ['الإدارة', 'المحاضرون', 'الأوبريشن', 'شؤون الطلاب', 'المالية', 'الدعم'],
    language: 'اللغة',
    theme: 'تغيير الوضع',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    usernameRequired: 'اسم المستخدم مطلوب',
    passwordRequired: 'كلمة المرور مطلوبة',
    loginFailed: 'فشل تسجيل الدخول',
    networkError: 'خطأ في الاتصال',
  },
} satisfies Record<'en' | 'ar', Record<string, string | string[]>>;

export type StaffLoginCopy = { [K in keyof typeof staffLoginCatalog.en]: typeof staffLoginCatalog.en[K] extends readonly string[] ? string[] : string };
